/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type Operator = 'lt' | 'lte' | 'eq' | 'neq' | 'gt' | 'gte';

export const Operator = {
    Lt: 'lt' as Operator,
    Lte: 'lte' as Operator,
    Eq: 'eq' as Operator,
    Neq: 'neq' as Operator,
    Gt: 'gt' as Operator,
    Gte: 'gte' as Operator
};